// PhotoID State: 
import React, { useEffect, useMemo, useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  Image,
  Platform,
} from "react-native";
import { useTranslation } from 'react-i18next';
import { loadCountries } from "../../../../../services/common.service";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import SearchIcon from "../../../../../../../../assets/images/search_icon.png";
import FlatListDataComponent from "../../../common/FlatListDataComponent";
import RadioSelectedIcon from "../../../../../../../../assets/images/Radio-Select-Button.png";
import Colors from "../../../../../constants/colors";

type StateItem = {
  stateid: number;
  stateAbbrivation: string;
  stateName: string
};

type ChooseStateOfIdStepProps = {
  onCountrySelected?: () => void;
};
export default function ChooseStateOfIdStep({ onCountrySelected }: ChooseStateOfIdStepProps) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const [states, setStates] = useState<StateItem[]>([]);
  const setSelectedIdPhotoIdStateAbbr = useSessionStore((s: SessionState) => s.setSelectedIdPhotoIdStateAbbr);
  const setSelectedIdPhotoIdStateName = useSessionStore((s: SessionState) => s.setSelectedIdPhotoIdStateName);
  const selectedIdPhotoIdCountry = useSessionStore((s: SessionState) => (s as any).selectedIdPhotoIdCountry);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const result = await loadCountries();
        const list = (result?.data ?? []) as any[];
        const targetCountryCode = selectedIdPhotoIdCountry || 'USA';
        const country = list.find((c) => c.CountryCode === targetCountryCode);
        const countryStates: StateItem[] = Array.isArray(country?.States) ? country.States : [];
        setStates(countryStates);
      } catch (e) {
        console.error('Failed to load states', e);
      }
    };
    fetchStates();
  }, [selectedIdPhotoIdCountry]);

  // Filter states by search
  const filteredState: StateItem[] = useMemo(() => {
    const q = search.toLowerCase();
    return states.filter((s) => (s.stateName || '').toLowerCase().includes(q));
  }, [states, search]);

  const onSelectState = (item: StateItem) => {
    setSelectedState(item.stateName);
    setSelectedIdPhotoIdStateName?.(item.stateName);
    setSelectedIdPhotoIdStateAbbr?.(item.stateAbbrivation);
    onCountrySelected?.();
  }

  return (
    <View style={styles.container}>
      <FlatListDataComponent
        title={t("CHOOSE_STATE_OF_ID")}
        subTitle={t("SELECT_STATE_OF_ISSUE")}
        searchPlaceHolder={t("COUNTRY_STEP_SEARCH_PLACEHOLDER")}
        searchValue={search}
        onSearchChangeText={setSearch}
        filteredData={filteredState}
        renderItem={(item) => (
          <TouchableOpacity
            style={styles.countryRow}
            onPress={() => {
              onSelectState(item);
            }}
          >
            <View style={{ flexDirection: 'row'}}>
              <View
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: 50,
                  overflow: 'hidden',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: Colors.searchBackground
                }}
              >
                <Text style={[styles.countryName, { paddingLeft: 0, fontSize: 12}]}>{item.stateAbbrivation.slice(0,2)}</Text>
              </View>
              <Text style={styles.countryName}>
                {item.stateName}
              </Text>
            </View>
            <View style={styles.radioButton}>
              {(selectedState !== null  && selectedState !== "") && (
                <Image
                  source={RadioSelectedIcon}
                  style={{ height: 20, width: 20}}   
                  resizeMode='contain'     
                />
              )}
            </View>
          </TouchableOpacity>
        )}
      />
      {/* <Text style={styles.title}>{t("CHOOSE_STATE_OF_ID")}</Text>
      <Text style={styles.subtitle}>
        {t("SELECT_STATE_OF_ISSUE")}
      </Text>
      <View style={styles.searchContent}>
        <Image
          source={SearchIcon}
          style={{ height: 20, width: 20, marginRight: 10}}
        />
        <TextInput
          style={styles.searchInput}
          placeholder={t("COUNTRY_STEP_SEARCH_PLACEHOLDER")}
          value={search}
          onChangeText={setSearch}
        />
      </View>
      <FlatList
        data={filteredState}
        keyExtractor={(item) => item.stateAbbrivation}
        style={{ flex: 1, width: "100%" }} 
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.countryRow}
            onPress={() => {
              setSelectedState(item.stateName);
              setSelectedIdPhotoIdStateName?.(item.stateName);
              setSelectedIdPhotoIdStateAbbr?.(item.stateAbbrivation);
              onCountrySelected?.();
            }}
          >
            <Text style={styles.countryName}>{item.stateName}</Text>
            <View
              style={[
                styles.radioOuter,
                selectedState === item.stateName && styles.radioOuterSelected,
              ]}
            >
              {selectedState === item.stateName && <View style={styles.radioInner} />}
            </View>
          </TouchableOpacity>
        )}
      /> */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 24,
    marginTop: 16,
    backgroundColor: Colors.white
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 6,
    color: "#111827",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginBottom: 16,
  },
  searchContent: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: "#F3F4F6",
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 10,
    alignItems: 'center'
  },
  searchInput: {
    fontSize: 16,
  },
  countryRow: {
    backgroundColor: Colors.white,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 0,
    justifyContent: 'space-between'
  },
  flag: {
    fontSize: 22,
    marginRight: 12,
  },
  countryName: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: 'Rubik',
    lineHeight: 20,
    color: Colors.darkGrey,
    paddingLeft: 16
  },
  radioContainer: {
    marginLeft: 12,
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D1D5DB',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.radioButtonFilled
  },
  radioOuter: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "#D1D5DB",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: '#D1D1D1'
  },
  radioOuterSelected: {
    borderColor: "#000",
  },
  radioInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#000",
  },
  selectedText: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: "500",
    color: "#111827",
  },
});
